import moment, { Moment } from 'moment';
import { useEffect, useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { setRankSellerList } from 'v3/data/store/Rank/RankSeller/actions';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { FlexContainer } from 'v3/pages/SellersRanking/Header/PeriodAndGroupInfo/styles';
import { FilterByWeekOrMonthAndPeriod } from 'v3/pages/SellersRanking/Header/SellerRankFilters';
import SellersInfor from 'v3/pages/SellersRanking/Header/SellerRankInfo';
import { Content } from 'v3/pages/SellersRanking/Header/styles';
import { getSellerRankingData } from 'v3/services/api';

export const SelleRankingHeader = () => {
  const [dateRange, setDateRange] = useState<[Moment | null, Moment | null]>([null, null]);
  const { filter } = useStoreSelector((store) => store.rankSeller);
  const { page, rowsPerPage } = useStoreSelector((store) => store.rankSeller.filter);

  const getSellerRankingDataRequest = async () => {
    if (filter.startDate) {
      const response = await getSellerRankingData(filter);
      setRankSellerList({ items: response.data.sellersRanking, count: response.data.count });
    } else {
      const today = moment();
      const start = moment(today).startOf('month').toISOString();
      const end = moment(today).endOf('month').toISOString();
      const selleRankFilters = {
        finalDate: end,
        startDate: start,
        page,
        rowsPerPage,
      };

      try {
        const response = await getSellerRankingData(selleRankFilters);
        setRankSellerList({ items: response.data.sellersRanking, count: response.data.count });
        return response.data;
      } catch (error) {
        showSnackbar('Erro ao carregar lista dos Ranks', 'error', true);
        console.error(showSnackbar);
      }
    }
  };

  useEffect(() => {
    getSellerRankingDataRequest();
  }, [filter]);

  return (
    <Content>
      <FlexContainer>
        <SellersInfor />
        <FilterByWeekOrMonthAndPeriod dateRange={dateRange} setDateRange={setDateRange} />
      </FlexContainer>
    </Content>
  );
};
